import _ from 'lodash'

import { DAILY_LOG_TYPE_LIST } from '../constants/dailyLog'

class Utils {
  /**
   * 0보다 크거나 같은 정수인지 체크한다.
   */
  isZeroOrPosInt(value) {
    value = Number(value)
    return Number.isInteger(value) && value >= 0
  }

  /**
   * 특정 데일리 로그 타입에 대한 정보를 리턴한다.
   */
  getDailyLogTypeIdByTypeNameEn(dailyLogTypeNameEn) {
    const foundType = _.find(
      DAILY_LOG_TYPE_LIST,
      dailyLogType => dailyLogType.dailyLogTypeNameEn === dailyLogTypeNameEn
    )
    return foundType.dailyLogTypeId
  }

}

const utils = new Utils()
export default utils